@if (!products) {
  <mat-spinner color="secondary"></mat-spinner>
}

@if (products && products.length == 0) {
  <div class="error">No Products Found</div>
}

@for (product of products; track product) {
  <a class="hero" [routerLink]="product.builderButton.link" [title]="product.image.alt">
    <img [src]="product.image.src" [alt]="product.image.alt" />
    <div class="title">
      <h1>{{ product.name }}</h1>
      <h3>{{ product.shortDescription }}</h3>
      @if (product.builderButton.link) {
        <button mat-flat-button color="primary" [routerLink]="product.builderButton.link">
          <span>
            @if (product.builderButton.iconPosition === 'LEFT') {
              <mat-icon [svgIcon]="product.builderButton.icon"></mat-icon>
            }
            {{product.builderButton.text}}
            @if (product.builderButton.iconPosition === 'RIGHT') {
              <mat-icon [svgIcon]="product.builderButton.icon"></mat-icon>
            }
          </span>
        </button>
      }
    </div>
  </a>
  <div class="description" [ngClass]="{collapsed: descriptionCollapsed, collapsible: collapsingDescriptionEnabled}" (click)="heroClicked()" #description>
    <span [innerHtml]="product.description"></span>
    @if (collapsingDescriptionEnabled) {
      <div class="actions">
        @if (descriptionCollapsed) {
          <button mat-stroked-button color="tertiary">
            <span>
              read more
              <mat-icon svgIcon="chevron-down"></mat-icon>
            </span>
          </button>
        }
        @if (!descriptionCollapsed) {
          <button mat-stroked-button color="tertiary">
            <span>
              read less
              <mat-icon svgIcon="chevron-up"></mat-icon>
            </span>
          </button>
        }
      </div>
    }
  </div>

  @if (product.childrenDisplayStyle == 'details') {
    @for (product of product.children; track product.id) {
      <mbnm-shop-detail-product-merch [product]="product">
      </mbnm-shop-detail-product-merch>
    }
  }

  @if (product.childrenDisplayStyle == 'thumb') {
    <mbnm-shop-detail-product-blocks [products]="product.children">
    </mbnm-shop-detail-product-blocks>
  }

  @if (products && products.length > 0 && products[0].reviewsTag) {
    <mbnm-reviews class="reviews" [tag]="products[0].reviewsTag"></mbnm-reviews>
  }
}
